<template>
  <div>
    <mainLayout />
    <checkAcces pageAccess="admin" />
    <div class="mainContent">
      <userManagement userStatus="labo" />
    </div>
  </div>
</template>

<script>
import mainLayout from "../layout/mainLayout.vue";
import checkAcces from "../components/checkAcces.vue";
import userManagement from "../components/user-management";

export default {
  components: {
    mainLayout,
    checkAcces,
    userManagement,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.container {
  margin-top: 100px;
}
.rounded {
  border-radius: 15px !important;
}
.mainContent {
  display: flex;
  flex-direction: row;
}

@media screen and (max-width: 900px) {
  .casTable {
    width: 100%;
  }
}
</style>
